// validates an input is an integer
(function () {
    'use strict';
    angular
        .module('app')
        .directive('integer',
            () => {
                const INTEGER_REGEXP = /^-?\d+$/;
                return {
                    require: 'ngModel',
                    link: (scope, elm, attrs, ctrl) => {
                        ctrl.$validators.integer = (modelValue, viewValue) => {
                            if (ctrl.$isEmpty(modelValue)) {
                                // consider empty models to be valid
                                return true;
                            }

                            if (INTEGER_REGEXP.test(viewValue)) {
                                // it is valid
                                return true;
                            }

                            // it is invalid
                            return false;
                        };
                    }
                };
            });
})();
